<template>
  <div>
    <div class="main-title">UDP服务器在线设备列表</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-input
              placeholder="搜索设备号"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              clearable
              @input="search(searchForm)">
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-refresh" size="small" @click="fetchList" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        style="width:100%">
        <el-table-column
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          prop="device_id"
          label="设备号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="wip"
          label="伪IP"
          width="180">
        </el-table-column>
        <el-table-column
          prop="address"
          label="设备IP地址"
          width="250">
        </el-table-column>
        <el-table-column
          prop="port"
          label="端口"
          width="80">
        </el-table-column>
        <el-table-column
          label="操作"
          width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="closeOil(scope.row)">断油</el-button>
            <el-button type="text" @click="openOil(scope.row)">恢复油路</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      searchForm: {
        query: ''
      },
      loading: false
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    fetchList () {
      this.loading = true
      this.$http.get('/udp/device/list').then(response => {
        this.loading = false
        if (response.data.success) {
          this.list = response.data.list
        }
      })
    },
    search (qs) {
      this.list = this.list.filter(r => r.device_id.indexOf(qs.query) >= 0)
    },
    closeOil (row) {
      this.$http.post('/udp/device/close', {
        device_id: row.device_id
      }).then(response => {
        if (response.data.success) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        } else {
          this.$message({
            type: 'success',
            message: '操作失败:' + response.data.message
          })
        }
      })
    },
    openOil (row) {
      this.$http.post('/udp/device/open', {
        device_id: row.device_id
      }).then(response => {
        if (response.data.success) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        } else {
          this.$message({
            type: 'success',
            message: '操作失败:' + response.data.message
          })
        }
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/DeviceList.vue